import React from 'react';
import FieldCard from 'src/components/10-atoms/Card/FieldCard';
import NumberBadge from 'src/components/10-atoms/NumberBadge';
import Typography from 'src/components/10-atoms/typography/Typography';
const TopicItem = ({ data: topic, ...fieldCardProps }) => {
    return (React.createElement(FieldCard, { title: React.createElement(Typography, null, topic.title), ...fieldCardProps },
        React.createElement(NumberBadge, { count: topic.questionCount })));
};
export default TopicItem;
